import GenericRequest, { METHOD_POST } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export default class MessagesRequest extends GenericRequest {

    term;
    page;
    filter;
    query_ids;
    limit;

    constructor(page, term = '', filter = null, query_ids = {}, limit = 10) {
        super(METHOD_POST, ApiEndpoints.MESSAGES);

        this.page = page;
        this.term = term;
        this.filter = filter;
        this.query_ids = query_ids;
        this.limit = limit;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.filter && this.filter !== 0 ) request.criteria.active = this.filter === 1;
        if ( this.limit ) request.criteria.limit = this.limit;

        if ( this.query_ids.machine_id ) request.criteria.machine_id = this.query_ids.machine_id;
        if ( this.query_ids.worker_id ) request.criteria.worker_id = this.query_ids.worker_id;
        if ( this.query_ids.company_id ) request.criteria.company_id = this.query_ids.company_id;
        if ( this.query_ids.construction_id ) request.criteria.construction_id = this.query_ids.construction_id;
        if ( this.query_ids.document_id ) request.criteria.document_id = this.query_ids.document_id;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/messages/to-refactor/shared/ws/MessagesRequest.js